import { AlertBanner, Button } from '@/components/ui';
import { AlertTriangle, TrendingDown, ShieldAlert, ArrowRight } from 'lucide-react';
import { partnerApi } from '@/lib/api-affiliate';

type AnomalyKind = 'clicks_drop' | 'conv_drop' | 'fraud_flag';

const KIND_META: Record<
  AnomalyKind,
  { title: string; tone: 'warning' | 'danger'; href: string; cta: string }
> = {
  clicks_drop: {
    title: 'Кликов сегодня меньше обычного',
    tone: 'warning',
    href: '/links',
    cta: 'Открыть ссылки',
  },
  conv_drop: {
    title: 'Конверсии снизились',
    tone: 'warning',
    href: '/conversions',
    cta: 'Открыть конверсии',
  },
  fraud_flag: {
    title: 'Замечена подозрительная активность',
    tone: 'danger',
    href: '/conversions',
    cta: 'Проверить трафик',
  },
};

function KindIcon({ kind }: { kind: AnomalyKind }) {
  if (kind === 'clicks_drop') return <TrendingDown className="h-4 w-4 shrink-0" />;
  if (kind === 'fraud_flag') return <ShieldAlert className="h-4 w-4 shrink-0" />;
  return <AlertTriangle className="h-4 w-4 shrink-0" />;
}

export default function AnomalyAlerts() {
  const { data, isLoading } = partnerApi.anomaly.useGet();

  if (isLoading || !data || !data.hasAnomaly) return null;

  const kind: AnomalyKind = data.kind ?? 'conv_drop';
  const meta = KIND_META[kind];

  return (
    <AlertBanner
      tone={meta.tone}
      title={
        <span className="inline-flex items-center gap-2">
          <KindIcon kind={kind} />
          {meta.title}
        </span>
      }
    >
      <div className="flex flex-col gap-2">
        {data.message && <span>{data.message}</span>}
        <div>
          <Button
            variant="ghost"
            size="xs"
            onClick={() => {
              window.location.href = meta.href;
            }}
          >
            {meta.cta}
            <ArrowRight className="h-3.5 w-3.5 shrink-0" />
          </Button>
        </div>
      </div>
    </AlertBanner>
  );
}
